import { motion } from 'framer-motion';
import { Link as RouterLink } from 'react-router-dom';
// material
import { Box, Button, Typography, Container, styled } from '@mui/material';
// components
import { MotionContainer, varBounceIn } from 'components/animate';
import Page from 'components/Page';
import { useSelector } from 'react-redux';
import Logo from 'components/Logo';
import publicUrl from 'utils/publicUrl';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  alignItems: 'center',
  paddingTop: theme.spacing(5),
  paddingBottom: theme.spacing(10)
}));

// ----------------------------------------------------------------------

export default function Page401() {
  const user = useSelector((state) => state.userSlice);
  const userGroup = user.group[0];

  return (
    <RootStyle title="401 Page Unauthorized | Aquatic monitoring system">
      <Container>
        <Box sx={{ px: 2.5, py: 3, display: 'inline-flex' }}>
          <Logo
            sx={{
              width: 60 * 1.085,
              height: 60
            }}
          />
        </Box>
        <MotionContainer initial="initial" open>
          <Box sx={{ maxWidth: 600, margin: 'auto', textAlign: 'center' }}>
            <motion.div variants={varBounceIn}>
              <Typography variant="h3" paragraph>
                Not Authorized
              </Typography>
            </motion.div>
            <Typography sx={{ color: 'text.secondary' }}>
              Sorry, but you are not authorized to access this page.
            </Typography>

            <motion.div variants={varBounceIn}>
              <Box
                component="img"
                src={publicUrl('/static/illustrations/illus_401_update.png')}
                sx={{ height: 336, mx: 'auto', my: { xs: 5, sm: 10 } }}
              />
            </motion.div>

            {userGroup ? (
              <Button to="/dashboard/app" size="large" variant="contained" component={RouterLink}>
                Go to Dashboard
              </Button>
            ) : (
              <Button to="/" size="large" variant="contained" component={RouterLink}>
                Go to Login Page
              </Button>
            )}
          </Box>
        </MotionContainer>
      </Container>
    </RootStyle>
  );
}
